import type { ProxyIntegrationError } from './types';

export const PROXY_READY_MESSAGE = 'byhelp.proxy.ready';
export const PROXY_SESSION_MESSAGE = 'byhelp.proxy.session';
export const PROXY_ROUTE_MESSAGE = 'byhelp.proxy.route';

export const PROXY_FRAME_PATH_MAX_LENGTH = 512;
export const PROXY_FRAME_PATH_PATTERN =
  /^(?!.*\.\.)\/(?:[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*)?(?:\?[A-Za-z0-9*._%+=&-]*)?$/;
export const PROXY_UUID_PATTERN =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

export const PROXY_HANDSHAKE_TIMEOUT_MS = 20000;

export const PROXY_ERROR_MESSAGES: Record<ProxyIntegrationError, string> = {
  'access-denied': 'Нет доступа к разделу «Прокси».',
  'not-configured': 'Кабинет «Прокси» не настроен для этой CRM.',
};

export const PROXY_HANDSHAKE_TIMEOUT_MESSAGE = 'Кабинет «Прокси» не отвечает.';
export const PROXY_HANDSHAKE_TIMEOUT_DESCRIPTION =
  'Проверьте подключение к интернету и повторите попытку.';
export const PROXY_RETRY_LABEL = 'Повторить';
